import React, { useEffect, useState } from 'react';
import { UserManager, User } from 'oidc-client-ts';
import oidcConfig from '../../utils/AuthConfig';

interface IOidcAuthProps {}

const OidcAuth: React.FunctionComponent<IOidcAuthProps> = (props) => {
  const [user, setUser] = useState<User | null>(null);
  const userManager = new UserManager(oidcConfig);

  useEffect(() => {
    userManager.getUser().then((user) => {
      if (user) {
        setUser(user);
      }
    });
    userManager.events.addUserLoaded((user) => {
      setUser(user);
    });

    userManager.events.addUserUnloaded(() => {
      setUser(null);
    });
  }, [userManager]);

  return (
    <div>
      {user ? (
        <div>
          <p>{user.profile.name}</p>
          {/* You can display more user information here */}
        </div>
      ) : (
        <h5 className="card-title">
          Please sign-in to see your profile information.
        </h5>
      )}
    </div>
  );
};

export default OidcAuth;
